module.exports = __webpack_public_path__ + "static/media/logo-light.be8ee89b.png";